(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-offer"] && !Shopify.designMode) return;
  try {
    /**
   * Choosing an offer sets the quantity that will be submitted — in every form
   * for this product, not just the one the radio sits in. The sticky buy bar
   * carries its own form, and it must not quietly add a single item after the
   * shopper has picked the bundle.
   *
   * Scoped to the section so a page listing several products stays correct.
   */
  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-offer-quantity]');
    if (!input) return;

    const scope = input.closest('.shopify-section') || document;
    const quantity = input.dataset.offerQuantity;

    scope.querySelectorAll('[data-quantity-input]').forEach((field) => {
      field.value = quantity;
      field.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["savings-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-calc]');
    if (!dialog) return;

    const d = dialog.dataset;
    const value = dialog.querySelector('[data-calc-value]');
    const range = dialog.querySelector('[data-calc-range]');
    const result = dialog.querySelector('[data-calc-result]');
    const min = Number(d.min);
    const max = Number(d.max);

    const money = new Intl.NumberFormat(d.locale || 'en', {
      maximumFractionDigits: 0,
    });

    const state = { amount: Number(range.value), age: 'modern', metal: 'steel' };

    /* "two-tone" -> d.factorTwoTone, matching data-factor-two-tone. */
    const factor = (option) =>
      Number(d['factor' + option.replace(/(^|-)(\w)/g, (m, _, c) => c.toUpperCase())]) || 100;

    /**
     * Rounds to something a person would say out loud. An estimate printed as
     * "$1,847" claims a precision this cannot have.
     */
    function tidy(n) {
      const step = n < 500 ? 10 : n < 5000 ? 50 : n < 50000 ? 100 : 500;
      return Math.round(n / step) * step;
    }

    function render() {
      const scale = (factor(state.age) * factor(state.metal)) / 10000;
      const low = tidy((state.amount * Number(d.baseMin) * scale) / 100);
      const high = tidy((state.amount * Number(d.baseMax) * scale) / 100);
      const c = d.currency;

      result.textContent =
        low === high
          ? c + money.format(low)
          : c + money.format(low) + ' – ' + c + money.format(high);

      range.value = state.amount;
      range.style.setProperty('--fill', ((state.amount - min) / (max - min)) * 100 + '%');

      dialog.querySelectorAll('[data-calc-preset]').forEach((b) => {
        b.setAttribute('aria-pressed', String(Number(b.dataset.calcPreset) === state.amount));
      });
    }

    function setAmount(n, redrawInput) {
      state.amount = Math.min(Math.max(Math.round(n) || min, min), max);
      if (redrawInput) value.value = money.format(state.amount);
      render();
    }

    /**
     * Typing: read the digits and leave the field alone, so the caret holds
     * its place. The one exception is a number above the maximum — there the
     * field has to be corrected straight away, or it would sit there showing a
     * figure the result underneath does not match. A number below the minimum
     * is left until blur: it is usually just a half-typed one.
     */
    value.addEventListener('input', () => {
      const digits = value.value.replace(/\D/g, '');
      if (digits === '') return;

      const typed = Number(digits);
      setAmount(typed, false);
      if (typed > max) value.value = String(max);
    });

    value.addEventListener('blur', () => setAmount(state.amount, true));
    value.addEventListener('focus', () => {
      value.value = String(state.amount);
    });

    range.addEventListener('input', () => setAmount(Number(range.value), true));

    dialog.addEventListener('click', (event) => {
      const preset = event.target.closest('[data-calc-preset]');
      if (preset) {
        setAmount(Number(preset.dataset.calcPreset), true);
        return;
      }

      const choice = event.target.closest('[data-calc-option]');
      if (!choice) return;

      const group = choice.dataset.calcGroup;
      dialog.querySelectorAll('[data-calc-group="' + group + '"]').forEach((b) => {
        b.setAttribute('aria-pressed', String(b === choice));
      });
      state[group] = choice.dataset.calcOption;
      hint(group);
      render();
    });

    /* One shared line per group, describing whichever option is selected. */
    function hint(group) {
      const line = dialog.querySelector('[data-calc-hint="' + group + '"]');
      const chosen = dialog.querySelector(
        '[data-calc-group="' + group + '"][aria-pressed="true"]'
      );
      if (line) line.textContent = chosen ? chosen.dataset.note || '' : '';
    }

    hint('age');
    hint('metal');

    const scaleMin = dialog.querySelector('[data-calc-scale-min]');
    const scaleMax = dialog.querySelector('[data-calc-scale-max]');
    if (scaleMin) scaleMin.textContent = d.currency + money.format(min);
    if (scaleMax) scaleMax.textContent = d.currency + money.format(max);

    setAmount(state.amount, true);

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-calc-open]')) {
        event.preventDefault();
        dialog.showModal();
      }
      if (event.target.closest('[data-calc-close]')) {
        dialog.close();
      }
    });

    /* Clicking the backdrop closes it; clicking the panel must not. */
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
